import { IconButton, Typography } from "@suraasa/placebo-ui"
import { OfferLetterType } from "api/resources/offerLetter/types"
import { Xmark } from "iconoir-react"
import { useMemo } from "react"

import { getPgCTLProdDetails } from "../helpers"
import CourseCards from "./CourseCards"

const CheckSVG = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 21C13.1819 21 14.3522 20.7672 15.4442 20.3149C16.5361 19.8626 17.5282 19.1997 18.364 18.364C19.1997 17.5282 19.8626 16.5361 20.3149 15.4442C20.7672 14.3522 21 13.1819 21 12C21 10.8181 20.7672 9.64778 20.3149 8.55585C19.8626 7.46392 19.1997 6.47177 18.364 5.63604C17.5282 4.80031 16.5361 4.13738 15.4442 3.68508C14.3522 3.23279 13.1819 3 12 3C9.61305 3 7.32387 3.94821 5.63604 5.63604C3.94821 7.32387 3 9.61305 3 12C3 14.3869 3.94821 16.6761 5.63604 18.364C7.32387 20.0518 9.61305 21 12 21ZM11.768 15.64L16.768 9.64L15.232 8.36L10.932 13.519L8.707 11.293L7.293 12.707L10.293 15.707L11.067 16.481L11.768 15.64Z"
        fill="#0F172A"
      />
    </svg>
  )
}

const WhatNext = ({
  handleClose,
  offerLetter,
}: {
  handleClose: () => void
  offerLetter: OfferLetterType
}) => {
  const pgctlDetails = getPgCTLProdDetails(offerLetter.product.slug)

  const points = useMemo(
    () => [
      pgctlDetails
        ? `Full access to ${pgctlDetails.text} modules`
        : "Full access to PgCTL modules.",
      //   "Full 1-year Suraasa Plus subscription",
      "Verified Skill Portfolio",
      "Dedicated support & mentoring",
    ],
    [pgctlDetails]
  )

  return (
    <div className="flex flex-col">
      <div className="relative flex h-[245px] w-full items-end overflow-hidden  bg-onSurface-900 sm:h-[177px] sm:rounded-t-2xl">
        <IconButton
          onClick={handleClose}
          className="absolute right-3 top-3 text-white hover:text-onSurface-900"
        >
          <Xmark />
        </IconButton>

        <Typography
          variant="title2"
          className="max-w-[146px] px-2 pb-4 text-white sm:max-w-none sm:px-4 sm:pb-3"
        >
          What’s Next?
        </Typography>
        <CourseCards
          isMini
          slug={offerLetter.product.slug}
          className="absolute -right-4 bottom-0 flex sm:hidden"
        />
        <CourseCards
          slug={offerLetter.product.slug}
          className="absolute bottom-[-19px] right-3 hidden rotate-6 px-2.5 pb-[45px] pt-2 sm:flex"
        />
      </div>
      <div className="px-2 py-4 sm:p-4">
        <Typography className="mb-2.5 text-onSurface-600">
          Your Admission Support Executive will reach out to guide you through
          the final admission formalities, including fee payment. <br />
          <br />
          Once that’s done, you’ll unlock:
        </Typography>
        <div className="mb-2.5 flex flex-col gap-1.5">
          {points.map(point => (
            <div key={point} className="flex items-center gap-0.75">
              <CheckSVG />
              <Typography>{point}</Typography>
            </div>
          ))}
        </div>
        <Typography className="text-onSurface-600">
          We’re excited to welcome you aboard!
        </Typography>
      </div>
    </div>
  )
}

export default WhatNext
